import { Injectable } from '@angular/core'
import { Rental } from '@tokeet/tv3-platform'
import { take } from 'rxjs/operators'
import { MatDialog } from '@angular/material/dialog'
import { EditPaymentScheduleDialogComponent } from './edit-payment-schedule-dialog.component'

@Injectable()
export class EditPaymentScheduleDialogService {
  constructor(private dialog: MatDialog) {}

  open(rental: Rental) {
    const config = {
      width: '100%',
      height: '100%',
      maxWidth: 'auto',
      backdropClass: '',
      position: {
        right: '0px',
        bottom: '0px',
      },
      data: { rental },
      panelClass: ['overlay-20', 'modal', 'side-modal-lg', 'right'],
    }

    const dialogRef = this.dialog.open(EditPaymentScheduleDialogComponent, config)

    if (dialogRef['_overlayRef'].overlayElement) {
      dialogRef['_overlayRef'].overlayElement.parentElement.className += ' dialog-wrapper'
    }

    dialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe(() => {
        dialogRef['_containerInstance']['_elementRef'].nativeElement.classList.add('side-closing')
      })

    return dialogRef
  }
}
